var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-shell"},[_c('analytics',{staticClass:"sm:mt-6 mt-0"}),_c('graph')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }